import React from "react";
import { useAuth } from "../auth/AuthContext";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import HomeButton from "../components/HomeButton";
import "../styles/myProfile.css";

const MyProfile = () => {
  const { user, logout } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

const isGiftTrial = user.plan === "gift_trial" && user.trialEndAt;

const trialEnd = isGiftTrial ? new Date(user.trialEndAt) : null;

const daysRemaining = trialEnd
  ? Math.max(
      0,
      Math.ceil((trialEnd - new Date()) / (1000 * 60 * 60 * 24))
    )
  : 0;

const totalDays = 14;

const progress = trialEnd && user.trialStartAt
  ? Math.min(
      100,
      Math.max(
        0,
        ((new Date() - new Date(user.trialStartAt)) /
          (trialEnd - new Date(user.trialStartAt))) *
          100
      )
    )
  : 0;


  if (!user) {
    return <p>{t("auth.not_logged")}</p>;
  }

  const handleDeleteAccount = () => {
    if (!window.confirm(t("profile.confirm_delete"))) return;


    // remove user's listings
    const listings = JSON.parse(localStorage.getItem("listings")) || [];
    const filtered = listings.filter((l) => l.userId !== user.uid);
    localStorage.setItem("listings", JSON.stringify(filtered));

    // remove user session
    logout();

    navigate("/");
  };

  return (
  <div className="edit-profile">

<HomeButton/>

    <h2>{t("profile.title")}</h2>

{isGiftTrial && (
  <div className="trial-banner">
    <h3>{t("profile.trialactive")}</h3>

<small>
      {t("profile.usingtrial")}
    </small>
  </div>
)}


    <p>
  <strong>{daysRemaining}</strong>{" "}
  {daysRemaining === 1
    ? t("profile.dayRemaining")
    : t("profile.daysRemaining")}
</p>

    <div className="trial-progress">
      <div
        className="trial-progress-fill"
        style={{ width: `${progress}%` }}
      />
    </div>


    <div style={{ marginBottom: "16px", fontSize: "14px" }}>
      <p>
        <strong>{t("profile.id")}:</strong> {user.uid}
      </p>

      <p>
        <strong>{t("profile.username")}:</strong> {user.username}
      </p>

      <p>
        <strong>{t("profile.email")}:</strong> {user.email}
      </p>
    </div>

    <button
      className="profile-save-btn"
      style={{ marginBottom: "10px" }}
      onClick={() => navigate("/profile/edit")}
    >
      {t("profile.edit")}
    </button>

    <button
      className="profile-save-btn"
      onClick={() => navigate("/my-listings")}
    >
      {t("profile.my_listings")}
    </button>

  </div>
 );
}

export default MyProfile;
